import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }
  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
    let originalShippingHTML = null;
    function updateFreeShippingBar() {
      const cartTotalRaw = document.querySelector('.cart__total-container .cart__total__value')?.innerHTML;
      const cartTotal = parseFloat(cartTotalRaw?.replace(/[^0-9.]/g, '') || '0');
      const bar = document.querySelector('free-shipping-bar');
      if (!bar) return;
      const threshold = parseFloat(bar.getAttribute('threshold-amount'));
      const shippingText = bar.querySelector('.shipping_text');
      const shippingAmountEl = bar.querySelector('.shipping_amount');
      const progressBar = bar.querySelector('progress-bar');
      if (!shippingText || !shippingAmountEl || !progressBar || isNaN(threshold)) return;
      if (!originalShippingHTML) originalShippingHTML = shippingText.innerHTML;
      if (cartTotal >= threshold) {
        shippingText.innerHTML = bar.getAttribute('reached_text');
      } else {
        const remaining = (threshold - cartTotal).toFixed(2);
        shippingText.innerHTML = originalShippingHTML;
        shippingText.querySelector('.shipping_amount').textContent = `$${remaining}`;
      }
      let percent = (cartTotal / threshold) * 100;
      if (percent > 100) percent = 100;
      progressBar.style.setProperty('--progress', `${percent}%`);
    }
    setTimeout(updateFreeShippingBar, 500);

    var initRebuy = () => { 
      setTimeout(function(){ 
        Rebuy.init(); 
      }, 500); 
    }; 

    document.addEventListener('rebuy:cart.change', function(event){ 
      initRebuy(); 
    });
  };

  open() {
    this.showDialog();
    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    console.log('noman testing');
    let originalShippingHTML = null;
    function updateFreeShippingBar() {
      const cartTotalRaw = document.querySelector('.cart__total-container .cart__total__value')?.innerHTML;
      const cartTotal = parseFloat(cartTotalRaw?.replace(/[^0-9.]/g, '') || '0');
      const bar = document.querySelector('free-shipping-bar');
      if (!bar) return;
      const threshold = parseFloat(bar.getAttribute('threshold-amount'));
      const shippingText = bar.querySelector('.shipping_text');
      const shippingAmountEl = bar.querySelector('.shipping_amount');
      const progressBar = bar.querySelector('progress-bar');
      if (!shippingText || !shippingAmountEl || !progressBar || isNaN(threshold)) return;
      if (!originalShippingHTML) originalShippingHTML = shippingText.innerHTML;
      if (cartTotal >= threshold) {
        shippingText.innerHTML = bar.getAttribute('reached_text');
      } else {
        const remaining = (threshold - cartTotal).toFixed(2);
        shippingText.innerHTML = originalShippingHTML;
        shippingText.querySelector('.shipping_amount').textContent = `$${remaining}`;
      }
      let percent = (cartTotal / threshold) * 100;
      if (percent > 100) percent = 100;
      progressBar.style.setProperty('--progress', `${percent}%`);
    }
    setTimeout(updateFreeShippingBar, 2000);
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
